import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicRichText } from '@prismicio/react'
import { PrismicLink } from '@prismicio/react'

const PartnerLogos = ({ slice }) => {
  return (
    <section className='component-logos mx-auto max-w-screen-xl p-6'>
      <div className='overflow-hidden rounded bg-white p-10 shadow-sm'>
        <div className={`component-${slice.slice_type}`}>
          <div className='prose mx-auto text-center lg:prose-lg'>
            <PrismicRichText field={slice.primary.title.richText} />
          </div>
          <div className='flex w-full flex-wrap items-center justify-center py-5 text-center'>
            {slice.items.map((customer, index) => {
              return (
                <div className='w-1/3 md:w-1/6' key={`customer-${index}`}>
                  {customer.link?.url ? (
                    <PrismicLink className='flex transform hover:scale-105' href={customer.link.url}>
                      <GatsbyImage image={customer.logo.gatsbyImageData} alt={customer.logo.alt || ''} />
                    </PrismicLink>
                  ) : (
                    <GatsbyImage image={customer.logo.gatsbyImageData} alt={customer.logo.alt || ''} />
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default PartnerLogos
